import { Button, Row } from 'antd'
import { DatabaseOutlined } from '@ant-design/icons'
import { downloadFile } from 'Services/WeaverUtils'
import GeneralTemplate from './general'

GenerateFile = GeneralTemplate({
  InputHandler: ({ startPlugin }) ->
    <div style={{ textAlign: 'center' }}>
      <Button
        onClick={-> startPlugin()}
        icon={<DatabaseOutlined />}
        type="primary"
        size="large"
        shape="round"
        ghost
      >
        Generate turtle file
      </Button>
    </div>
  ResponseHandler: ({ response }) ->
    <Button
      shape="round"
      type="primary"
      onClick={ -> downloadFile(response.fileId, 'export.ttl', true)}
    >
      Download file
    </Button>
})

export default GenerateFile
